<div class="layoutBlock">
    <div class="entrypageSideLeft"></div>

    <div class="entrypageCenter">
        <form [formGroup]="attributeSelectForm" >
            <select formControlName="attributesFC" [(ngModel)]="selectedAttribute">
                <option *ngFor="let att of attributes" [ngValue]="att">
                    {{ att.type }}: {{ att.useCase }}
                </option>
            </select>
            <br>
            <input type="text" [(ngModel)]="selectedProcessId" formControlName="processIdFC">
            <br>
            <button type="button" (click)="loadAttributes()">Laden</button>
            <hr>
        </form>

        <erp-workflow-operation [processType]="'ura'" [useCaseIdent]="'ura_neu'" [processId]="1" [saveWorkflowOperationStep]="formSaved"></erp-workflow-operation>
        <button type="button" (click)="notifyParentSaved()">Durchführen</button>
    </div>

    <div class="entrypageSideRight"></div>
</div>
